module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAtUlEQVRYR+2W0Q3CMAxELxuxQbsBbEBHuE1yI5QN6AZ0AzYCuQLUUH7rRMKW8ps7vfgcJ1SuVFkfYSAIfAiQPAA4OjXlJOluWmsDNwCdk4FZUv9tYABgx6NGSWNhwEP1l0akIAgUBEj2KaXH3g2Zc57fGus5YLE47y3+uv8iaYl8OwbMjT2BBwFJNnWXihQEgXYIkLRces6B8jsmWX0hsZXs5DEHAFw3K5mT8EamnSYMAn9L4AkhrTEhoED4xwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = +HEJ
// module chunks = 1